import { cn } from "@/lib/utils";
import { statusClass, familyClass } from "@/lib/format";

export function StatusBadge({ status, label, family, className }) {
  const cls = family ? familyClass(family) : statusClass(status);
  return (
    <span
      data-testid={`status-badge-${String(label || status).toLowerCase().replace(/\s+/g, "-")}`}
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium capitalize whitespace-nowrap",
        cls, className
      )}
    >
      {label || String(status).replace(/_/g, " ")}
    </span>
  );
}
